import { useState } from "react";
import { useStore } from "../../store";
import InlineLoader from "../../components/atoms/inlineLoader";
import ErrorAlert from "../../components/atoms/alerts/errorAlert";
import SuccessAlert from "../../components/atoms/alerts/successAlert";
const RequestReset = () => {
    const title = 'Company Login';
    const { layoutStore } = useStore();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [success, setSuccess] = useState("");
    return (
        <>
            <div className="flex min-h-full flex-col justify-center py-12 sm:px-6 lg:px-8">
                <div className="sm:mx-auto sm:w-full sm:max-w-md">
                    <h1 className='font-black text-2xl text-center cursor-pointer border-b-2 pb-2 text-blue-700'
                    >
                        {title}
                    </h1>
                    <h2 className="mt-6 text-center text-3xl font-bold tracking-tight text-gray-900">
                        Request Password Reset
                    </h2>
                </div>

                <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
                    <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
                        {error && <ErrorAlert title={error} />}
                        {success && <SuccessAlert title={success}
                            message="Please check your email for the reset link. If you don't see it in your inbox, please check your spam folder."
                        />}
                        <form className="space-y-6"
                            onSubmit={(e) => {
                                e.preventDefault();
                                setLoading(true);
                                setError("");
                                setSuccess("");
                                const email = e.target.email.value;
                                layoutStore.sendResetLink(email).then(resp => {
                                    if (resp.error) {
                                        setError(resp.error);
                                    }
                                    else {
                                        setSuccess(resp.message);
                                        setTimeout(() => {
                                            window.location.href = "/login";
                                        }, 8000);
                                    }
                                    setLoading(false);
                                })
                            }}
                        >

                            <div>
                                <label htmlFor="email" className="block text-sm font-medium text-gray-700">
                                    Registered Email
                                </label>
                                <div className="mt-1">
                                    <input
                                        id="email"
                                        name="email"
                                        type="email"
                                        autoComplete="current-email"
                                        required
                                        className="block w-full appearance-none rounded-md border border-gray-300 px-3 py-2 placeholder-gray-400 shadow-sm focus:border-blue-500 focus:outline-none focus:ring-blue-500 sm:text-sm"
                                    />
                                </div>
                            </div>
                            <div className="flex items-center justify-between">

                            </div>

                            <div>
                                <button
                                    type="submit"
                                    disabled={loading}
                                    className="flex w-full justify-center rounded-md border border-transparent bg-blue-600 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                                >

                                    {
                                        loading ? "Please wait..." : "Request Password Reset"
                                    }
                                    {
                                        loading && <InlineLoader />
                                    }
                                </button>
                            </div>
                        </form>

                    </div>
                </div>
            </div>

        </>
    )
}
export default RequestReset;